export function isGeneralAdminView(user, demoMode = false) {
  return !demoMode && ["admin", "superadmin"].includes(user?.role);
}

export function requestedReadStores(user, selection, stores, demoMode = false) {
  if (!user) return [];
  if (demoMode && ["admin", "superadmin"].includes(user.role)) return stores.map(store => Number(store.id));
  if (!isGeneralAdminView(user, demoMode)) return [Number(user.storeId)].filter(Boolean);
  if (selection === "all") return stores.map(store => Number(store.id));
  const selected = Number(selection);
  return stores.some(store => Number(store.id) === selected) ? [selected] : [];
}

// Operational screens never infer a store from an administrative login.
// Carol selects one store; the technical owner's explicit general view remains separate.
export function operationalStoreIds(user, selectedStores) {
  if (!user) return [];
  if (!["admin", "superadmin"].includes(user.role)) {
    return Number(user.storeId) > 0 ? [Number(user.storeId)] : [];
  }
  const ids = [...new Set((selectedStores ?? [user.storeId]).map(Number).filter(id => Number.isInteger(id) && id > 0))];
  return user.role === "admin" && ids.length !== 1 ? [] : ids;
}

export function operationalRecords(records, user, selectedStores, ownerStoreId) {
  const stores = operationalStoreIds(user, selectedStores);
  return (records || []).filter(record => {
    const owner = record?.responsavelId ?? record?.consultantId;
    const store = Number(record?.storeId ?? record?.lojaAtual ?? ownerStoreId?.(owner));
    return stores.includes(store) && (user?.role !== "consultant" || Number(owner) === Number(user.id));
  });
}

export function operationalConsultants(users, user, selectedStores) {
  const stores = operationalStoreIds(user, selectedStores);
  return users.filter(item => item.role === "consultant" && stores.includes(Number(item.storeId)));
}
